module.exports = __webpack_public_path__ + "static/media/usb.7073649c.png";